import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

const $window = $(window);
const list = [];

function scrollfire(animated = true) {

	const bottom = window.innerHeight;
	
	while(list.length) {

		const el = list[0];
		const top = el.getBoundingClientRect().top;
		
		if (top < bottom) {
			el.classList.add(animated ? 'anim-fire' : 'static-fire');
			list.splice(0, 1);
		} else {
			break;
		}
	}
}

manager.register('scrollfire', (component) => {
	list.push(component);
});

manager.plugin('scrollfire', (target) => {
	scrollfire();
});

$window.scroll(() => scrollfire());
